<template>
  <a :href="`mailto:${email}`">{{email}}</a>
</template>
<script setup lang="ts">
  const props = defineProps<{ account?: string }>()
  const email = computed(() => `${props?.account ?? 'support'}@legendtrading.com`)
</script>
